import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import CloseImage from "assets/images/general_old/close.svg";
import TextComponent from "components/TextComponent";
import { CallAPI } from "actions/General";
import TextAreaComponent from "components/TextAreaComponent";
import TextRadioComponent from "components/TextRadioComponent";
import ButtonComponent from "components/ButtonComponent";
import LoaderComponent from "components/LoaderComponent";
import ErrorComponent from "components/ErrorComponent";

function EditSubscription({ editId, setEditId, getSubscriptionsList }) {
  const [loader, setLoader] = useState(false);
  const [loaderType, setLoaderType] = useState("");
  const [apiError, setApiError] = useState("");
  const [values, setValues] = useState({
    title: "",
    monthly_ngn_price: "",
    monthly_usd_price: "",
    monthly_cad_price: "",
    yearly_ngn_price: "",
    yearly_usd_price: "",
    yearly_cad_price: "",
    monthly_credits: "",
    yearly_credits: "",
    monthly_credits_expires: "",
    yearly_credits_expires: "",
    auto_charged: false,
    is_cpd: false,
    detail: "",
  });
  const updateFormValues = (name, value) => {
    setValues({ ...values, [name]: value });
  };
  const getSubscriptionDetails = async () => {
    const result = await CallAPI(
      "GET_SUBSCRIPTION_PLAN_DETAIL",
      null,
      editId,
      setLoader,
      setApiError,
      null
    );
    if (result.status) {
      const subscriptionItem = result.data;
      setValues({
        title: subscriptionItem.title,
        monthly_ngn_price: parseInt(subscriptionItem.monthly_ngn_price),
        monthly_usd_price: parseInt(subscriptionItem.monthly_usd_price),
        monthly_cad_price: parseInt(subscriptionItem.monthly_cad_price),
        yearly_ngn_price: parseInt(subscriptionItem.yearly_ngn_price),
        yearly_usd_price: parseInt(subscriptionItem.yearly_usd_price),
        yearly_cad_price: parseInt(subscriptionItem.yearly_cad_price),
        monthly_credits: parseInt(subscriptionItem.monthly_credits),
        yearly_credits: parseInt(subscriptionItem.yearly_credits),
        monthly_credits_expires: parseInt(
          subscriptionItem.monthly_credits_expires
        ),
        yearly_credits_expires: parseInt(
          subscriptionItem.yearly_credits_expires
        ),
        auto_charged: subscriptionItem.auto_charged,
        detail: subscriptionItem.detail,
        is_cpd: subscriptionItem.is_cpd,
      });
    }
  };
  useEffect(() => {
    getSubscriptionDetails();
  }, [editId]);

  const updateSubscription = async () => {
    setLoaderType("save");
    console.log("values", values);
    let result = await CallAPI(
      "UPDATE_SUBSCRIPTION_PLAN_DETAIL",
      {
        title: values.title,
        monthly_ngn_price: parseInt(values.monthly_ngn_price),
        monthly_usd_price: parseInt(values.monthly_usd_price),
        monthly_cad_price: parseInt(values.monthly_cad_price),
        yearly_ngn_price: parseInt(values.yearly_ngn_price),
        yearly_usd_price: parseInt(values.yearly_usd_price),
        yearly_cad_price: parseInt(values.yearly_cad_price),
        monthly_credits: parseInt(values.monthly_credits),
        yearly_credits: parseInt(values.yearly_credits),
        monthly_credits_expires: parseInt(values.monthly_credits_expires),
        yearly_credits_expires: parseInt(values.yearly_credits_expires),
        auto_charged: values.auto_charged,
        detail: values.detail,
        is_cpd: values.is_cpd,
      },
      editId,
      setLoader,
      setApiError,
      null
    );
    if (result.status) {
      setEditId("");
      getSubscriptionsList();
    }
  };
  return (
    <div className={`custom-modal `}>
      {loader && loaderType === "load_detail" && <LoaderComponent classes="" />}
      {apiError && <ErrorComponent text={apiError} variant="danger" />}
      <div className="detail subscriptions">
        <img
          className="close"
          src={CloseImage}
          onClick={() => setEditId("")}
          alt="close"
        />
        <div className="d-flex flex-wrap justify-content-evenly gap-3">
          <TextComponent
            classes={""}
            name={"title"}
            value={values.title}
            setValue={updateFormValues}
            error={""}
            label={"title"}
            placeholder={"title"}
            disabled={true}
            required={true}
          />
          <TextRadioComponent
            name={"auto_charged"}
            label={"auto_charged"}
            placeholder={"auto_charged"}
            value={values.auto_charged}
            setValue={updateFormValues}
            classes={""}
            required={true}
          />
          <TextComponent
            classes={""}
            name={"monthly_usd_price"}
            value={values.monthly_usd_price}
            setValue={updateFormValues}
            error={""}
            label={"monthly usd"}
            placeholder={"monthly usd"}
            type="number"
            required={true}
          />
          <TextComponent
            classes={""}
            name={"monthly_cad_price"}
            value={values.monthly_cad_price}
            setValue={updateFormValues}
            error={""}
            label={"monthly cad"}
            placeholder={"monthly cad"}
            type="number"
            required={true}
          />
          <TextComponent
            classes={""}
            name={"monthly_ngn_price"}
            value={values.monthly_ngn_price}
            setValue={updateFormValues}
            error={""}
            label={"monthly ngn"}
            placeholder={"monthly ngn"}
            type="number"
            required={true}
          />
          <TextComponent
            classes={""}
            name={"yearly_usd_price"}
            value={values.yearly_usd_price}
            setValue={updateFormValues}
            error={""}
            label={"yearly usd"}
            placeholder={"yearly usd"}
            type="number"
            required={true}
          />
          <TextComponent
            classes={""}
            name={"yearly_cad_price"}
            value={values.yearly_cad_price}
            setValue={updateFormValues}
            error={""}
            label={"yearly cad"}
            placeholder={"yearly cad"}
            type="number"
            required={true}
          />
          <TextComponent
            classes={""}
            name={"yearly_ngn_price"}
            value={values.yearly_ngn_price}
            setValue={updateFormValues}
            error={""}
            label={"yearly ngn"}
            placeholder={"yearly ngn"}
            type="number"
            required={true}
          />
          <TextComponent
            classes={""}
            name={"monthly_credits"}
            value={values.monthly_credits}
            setValue={updateFormValues}
            error={""}
            label={"monthly_credits"}
            placeholder={"monthly_credits"}
            type="number"
            required={true}
          />
          <TextComponent
            classes={""}
            name={"yearly_credits"}
            value={values.yearly_credits}
            setValue={updateFormValues}
            error={""}
            label={"yearly_credits"}
            placeholder={"yearly_credits"}
            type="number"
            required={true}
          />
          <TextComponent
            classes={""}
            name={"monthly_credits_expires"}
            value={values.monthly_credits_expires}
            setValue={updateFormValues}
            error={""}
            label={"monthly_credits_expires"}
            placeholder={"credits_expires"}
            overLayText={"months"}
            type="number"
            required={true}
          />
          <TextComponent
            classes={""}
            name={"yearly_credits_expires"}
            value={values.yearly_credits_expires}
            setValue={updateFormValues}
            error={""}
            label={"yearly_credits_expires"}
            placeholder={"credits_expires"}
            overLayText={"months"}
            type="number"
            required={true}
          />

          <div>
            <TextAreaComponent
              classes={"w-100"}
              name={"detail"}
              value={values.detail}
              setValue={updateFormValues}
              error={""}
              label={"detail"}
              placeholder={"detail"}
              required={true}
            />
          </div>
          <div className="ms-auto">
            <ButtonComponent
              text="update"
              onClick={updateSubscription}
              variant="blue-1"
              loading={loader && loaderType === "save"}
              disabled={loader && loaderType === "save"}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
EditSubscription.propTypes = {
  editId: PropTypes.string.isRequired,
  setEditId: PropTypes.func.isRequired,
  getSubscriptionsList: PropTypes.func.isRequired,
};
export default EditSubscription;
